import React, {Component} from 'react';
import {Modal, Table} from 'react-bootstrap';
import {translate} from 'react-i18next';
import swal from 'sweetalert';
import FlatButton from 'material-ui/FlatButton';
import { functionalCriterial } from '../../../libs/services';
import PrintManager from '../../generics/printManager';

var Config = require('../../../config');
var socket = "";

class ModalReport extends Component{
	constructor(props){
		super(props);

		this.handleShow = this.handleShow.bind(this);
		this.handleClose = this.handleClose.bind(this);
		this.printReport = this.printReport.bind(this);
		this.handleChange = this.handleChange.bind(this);
		this.checkAll = this.checkAll.bind(this);
		this.printSingleFile = this.printSingleFile.bind(this);
		this.printMultipleFiles = this.printMultipleFiles.bind(this);

		this.state = {
			show: false,
			folios:[],
			select_multi:{},
			copies:1,
			check_all:false,
			print_individual:{}
		}
	}

	componentDidMount(){
		this.props.onRef(this);

		socket= this.props.socket !== undefined && this.props.socket !== ""  ? this.props.socket : new WebSocket("wss://localhost:2018");

		//console.log(socket.readyState, socket.OPEN)
		if(socket.readyState !== socket.OPEN){
			//socket.send("initfp");
		}
		
		socket.onerror = (event)=> {
			console.log(event);
		};

		socket.onmessage = (event) => {
			var res = JSON.parse(event.data);
			if(res.Error === "No hay impresora configurada para imprimir")
				swal('¡Error!', res.Error, 'error');
		}	
	}

	componentWillUnmount(){
		this.props.onRef(null);
	}

	async handleShow(units, file){
		const criteriaMulti = await functionalCriterial("PAT_MUL_UNIT_CTRL_TRANS");

		if (criteriaMulti !== undefined) {
			this.setState({
				select_multi: criteriaMulti
			});
		}

		const criteriaIndividual = await functionalCriterial("PRINT_TRANSFUSIONAL_CONTROL_INDIVIDUAL");

		if (criteriaIndividual !== undefined) {
			this.setState({
				print_individual: criteriaIndividual
			});
		}


		var f = [];
		if(file === 'unit_reserve_doc'){
			units.map((u)=>{
				f.push({
					id:u.unit_id,
					folio:u.unit,
					check:false
				})
					
			})
		}else{
			units.map((u)=>{
				if(u.folio !== undefined && u.refund_date === null){
					f.push({
						id:u.unit_id,
						folio:u.unit,
						code:u.code,
						number:u.component_number,
						check:false
					})
				}		
			})
		}
		this.setState({show:true, folios:f, file: file !== undefined ? file : "unit_sent_inform"});
		
	}

	handleClose(){
		this.setState({show:false, folios:[]});
	}
	
	selectFolio(e, i){

		if(this.state.select_multi.value !== undefined){
			if(this.state.select_multi.value === 'YES'){
				this.state.folios[i].check = e.target.checked ? true : false;
			}else{
				this.state.folios.map((f)=>{
					f.check = false;
				});

				this.state.folios[i].check = e.target.checked ? true : false;				
			}
		}
		
		this.forceUpdate();
	}

	async printReport(e){
		e.preventDefault();
		var error = '';
		var obj = {
			health_facilities_id: parseInt(sessionStorage.getItem("health_facilities_id"),10),
			id: this.props.match.params.id,
			file_type: this.state.file,
			nEtiqueta: [0],
			copies: parseInt(this.state.copies)
		};

		if(obj.copies < 1){
			error = 'Debe de enviar por lo menos una copia';
		}

		if(this.state.file !== "p_plasmatic_delivered"){
			obj.ids = [];
			this.state.folios.map((f)=>{
				if(f.check){
					obj.ids.push(f.id)
				}
			});

			if(obj.ids.length === 0){
				error = 'Debe marcar por lo menos una unidad';
			}
		}		

		if (error !== '') {
			swal('Error', error, 'error');
			return;
		}

		const type = await this.props.getDocumentType(obj.file_type);
		
		if(type === undefined) {
			swal('Error', 'Error al intentar obtener el tipo de documento', 'error');
			return;
		}

		if (this.state.print_individual?.value === "YES") {
			this.printMultipleFiles(obj, type);

			this.setState({ show: false});
		}
		else {
			this.props.waiting.handleShow('Imprimiendo...');

			const response = await this.printSingleFile(obj, type);

			this.props.waiting.handleClose();

			if(response !== undefined){
				this.setState({ show: false});	
			}
		}
	}

	async printSingleFile(data, type) {
		var document;
			
		if(type.print_type === 'template'){
			document = await this.props.printDocumentTemplate(data, type.print_automatically);
		}else if(type.print_type === 'external'){
			document = await this.props.printDocumentExternal(data, type.print_automatically);
		}

		return document;
	}

	printMultipleFiles(data, type) {
		data.ids.map(unit_id => {
			PrintManager.add(async () => {
                const obj = {
                    ...data,
					ids: [ unit_id ]
                };

				await this.printSingleFile(obj, type);
			});
		});
	}

	handleChange(e){
		this.setState({[e.target.name]: e.target.value});
	}

	checkAll(e){
		this.setState({check_all: !this.state.check_all});

		var folios = this.state.folios;

		folios.map((f)=>{
			if(e.target.checked){
				f.check = true;
			}else{
				f.check = false;
			}
		})

		this.setState({folios:folios});
	}

	render(){
		const {t} = this.props;
		return (
			<Modal bsSize={this.state.file === 'unit_reserve_doc' || this.state.file === 'p_plasmatic_delivered' ? "sm" 
					: this.state.file === 'unit_sent_inform' ? ""			
					: "sm"} 
				show={this.state.show} onHide={this.handleClose}>
		       	<Modal.Header closeButton>
		        	<Modal.Title>
						{this.state.file === 'unit_reserve_doc' || this.state.file === 'p_plasmatic_delivered' ?
							'Impresión'
						: 'Informe Control Transfusional'}						
					</Modal.Title>
		        </Modal.Header>
		        <Modal.Body >
		        	<div className="row">
		        		<div className="col-xs-12">
		        			{this.state.file !== 'p_plasmatic_delivered' &&							
								<div className="col-xs-12 col-sm-8 col-sm-offset-2">
									<Table responsive hover>
										<thead>
											{this.state.file === 'unit_reserve_doc' ?
												<tr>
													<th>
														{this.state.select_multi.value === 'YES' &&
															<input type="checkbox" name="check_all" id="check_all" value={this.state.check_all}
																onChange={(e)=>this.checkAll(e)} checked={this.state.check_all} />
														}
													</th>
													<th>No. Unidad</th>
												</tr>
											:<tr>
													<th>
														{this.state.select_multi.value === 'YES' &&
															<input type="checkbox" name="check_all" id="check_all" value={this.state.check_all}
																onChange={(e)=>this.checkAll(e)} checked={this.state.check_all} />
														}
													</th>
													<th>No. Unidad</th>
													<th>Componente</th>
													<th>No. Componente</th>
												</tr>}
										</thead>
										<tbody>
											{this.state.file === 'unit_reserve_doc' ?
												this.state.folios.map((s, i)=>{
													return <tr key={i}>
														<td>
															<input type="checkbox" checked={s.check}
																onChange={(e)=>this.selectFolio(e, i)} />
														</td>
														<td>
															{s.folio}
														</td>
													</tr>
												})
											
											: this.state.folios.map((s, i)=>{
												return <tr key={i}>
													<td>
														<input type="checkbox" checked={s.check}
															onChange={(e)=>this.selectFolio(e, i)} />
													</td>
													<td>
														{s.folio}
													</td>
													<td>{s.code}</td>
													<td>{s.number}</td>
												</tr>
											})}
										</tbody>
									</Table>
								</div>
							}
			        		<div className="col-xs-12 col-sm-8 col-sm-offset-2">
				        		<div className={this.state.file !== 'p_plasmatic_delivered' ? "col-xs-12 col-sm-6" : "col-xs-12"}>
				        			<span className="span-min">Copias</span>
				        			<input type="number" className="form-control hour-input" value={this.state.copies}
				        				name="copies" id="copies" onChange={this.handleChange} min="1" />
				        		</div>
			        		</div>
		        		</div>
		        	</div>
		        </Modal.Body>
		        <Modal.Footer>
		        	<FlatButton primary={true} label={t('content.generics.buttons.print')}  onClick={this.printReport}/>
		        	<FlatButton primary={true} label={t('content.generics.buttons.reset')}  onClick={this.handleClose}/>
		        </Modal.Footer>
	      	</Modal>
		)
	}
}

export default translate('translations')(ModalReport)